import { ChildApplyFactory } from './childApplyFactory';

import type {
  ChildApplyEntity,
  ChildApplyPropsPub,
  ChildApplyPropsPvt,
} from './childApplyEntity';
import type { ChildApplyIRepository } from './childApplyIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { ChildApplyJsonPub, ChildApplyJsonPvt } from '@/types/domain/childApply/entities/childApplyEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class ChildApplyRepository extends AppsyncRepository<
  ChildApplyEntity,
  ChildApplyPropsPvt,
  ChildApplyJsonPvt,
  ChildApplyPropsPub,
  ChildApplyJsonPub
> implements ChildApplyIRepository {
  private factory = new ChildApplyFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryChildApplyChildApplyEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
